import { isRequired } from '../../utils/formValidators';
import { FormSchema } from '../../models/Form';

export const createTeamSchema: FormSchema = ({
  teamName: {
    type: 'text',
    label: 'TEAM_NAME',
    required: true,
  },
  paypalUrl: {
    type: 'text',
    label: 'PAYPAL_URL',
    placeholder: 'PAYPAL_URL_PLACEHOLDER',
    required: false,
  },
});

export const validationSchema = {
  teamName: [isRequired],
};
